import { ModelsUseCase } from '../../../data/usecases/models'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

type fetchListAllFactorsProps = {
  page: number
}

type filterListAllFactorsProps = {
  page: number
  factor: string
  typeToService: string
}

type resetFactorsProps = {
  cdTypeToService: number
  cdFactor: number
}

export const fetchAllFactors = () => {
  return new ModelsUseCase('/fator/findAll', makeAxiosHttpClient())
}

export const fetchModelFactors = ({
  cdTypeToService,
  cdFactor
}: resetFactorsProps) => {
  return new ModelsUseCase(
    `/fator/getFatorText?cdFator=${cdFactor}&cdTipoAvaliacao=${cdTypeToService}`,
    makeAxiosHttpClient()
  )
}

export const fetchListAllFactors = ({ page = 1 }: fetchListAllFactorsProps) => {
  return new ModelsUseCase(`/fator?page=${page}`, makeAxiosHttpClient())
}

export const filterListAllFactors = ({
  page = 1,
  factor,
  typeToService
}: filterListAllFactorsProps) => {
  return new ModelsUseCase(
    `/fator/filter?fator=${factor}&tipoAvaliacao=${typeToService}&page=${page}`,
    makeAxiosHttpClient()
  )
}

export const resetFactors = ({
  cdTypeToService,
  cdFactor
}: resetFactorsProps) => {
  return new ModelsUseCase(
    `/fator/reset?cdFator=${cdFactor}&cdTipoAvaliacao=${cdTypeToService}`,
    makeAxiosHttpClient()
  )
}

export const saveFactorModel = ({
  cdFactor,
  cdTypeToService
}: resetFactorsProps) => {
  return new ModelsUseCase(
    `/fator/save?cdFator=${cdFactor}&cdTipoAvaliacao=${cdTypeToService}`,
    makeAxiosHttpClient()
  )
}

export const updateFactorModel = () => {
  return new ModelsUseCase(`/fator/update`, makeAxiosHttpClient())
}
